<template>
  <div class="d-flex align-center">
    <div class="user-info" style="width: 100%">
      <template v-if="editMode">
        <p class="body-1 pb-0 mb-0 font-weight-bold">{{ $t('companyNameLabel') }}:</p>
        <v-text-field disabled outlined dense class="body-2" :value="this.company.name1" v-model="companyInfo.name1">
        </v-text-field>
        <p class="body-1 pb-0 mb-0 font-weight-bold">{{ $t('companyNumberLabel') }}:</p>
        <v-text-field disabled outlined dense class="body-2" :value="this.company.companyNumber"></v-text-field>
        <p class="body-1 pb-0 mb-0 font-weight-bold">{{ $t('companyCityLabel') }}:</p>
        <v-text-field outlined dense class="body-2" :value="this.company.city" v-model="companyInfo.city">
        </v-text-field>
        <p class="body-1 pb-0 mb-0 font-weight-bold">{{ $t('addressLabel') }}:</p>
        <v-text-field outlined dense class="body-2" :value="this.company.address" v-model="companyInfo.address">
        </v-text-field>
        <p class="body-1 pb-0 mb-0 font-weight-bold">{{ $t('postalCodeLabel') }}:</p>
        <v-text-field outlined dense class="body-2" :value="this.company.postalCode" v-model="companyInfo.postalCode">
        </v-text-field>

        <div>
          <v-btn class="primary" @click="saveChanges()">{{ $t('saveDataLabel') }}</v-btn>
          <v-btn class="red ml-4 white--text" @click="editMode = false">{{ $t('cancelLabel') }}</v-btn>
        </div>
      </template>
      <template v-else>
        <v-row class="">
          <v-col cols="6" class="">
            <p class="body-1 pb-0 mb-0 font-weight-bold">{{ $t('companyNameLabel') }}:</p>
            <p class="body-2">{{ this.company.name1 }}</p>
            <p class="body-1 pb-0 mb-0 font-weight-bold">{{ $t('companyNumberLabel') }}:</p>
            <p class="body-2">{{ this.company.companyNumber }}</p>
            <p class="body-1 pb-0 mb-0 font-weight-bold">{{ $t('companyCityLabel') }}:</p>
            <p class="body-2">{{ this.company.city }}</p>
            <p class="body-1 pb-0 mb-0 font-weight-bold">{{ $t('addressLabel') }}:</p>
            <p class="body-2">{{ this.company.address }}</p>
            <p class="body-1 pb-0 mb-0 font-weight-bold">{{ $t('postalCodeLabel') }}:</p>
            <p class="body-2">{{ this.company.postalCode }}</p>
            <div v-if="isAdmin" class="">
              <v-checkbox v-model="canEditPrice" :label="$t('profileCheckboxLabel')"></v-checkbox>
              <div class="mb-6">
                <p class="body-1 pb-0 mb-0 font-weight-bold">{{$t('deliveryInformationLabel')}}: </p>
                <v-text-field v-model="deliveryInformation" single-line outlined hide-details dense class="body-2">
                </v-text-field>
              </div>
              <v-btn :loading="savingDeliveryInformation" height="" min-height="100%" class="green white--text"
                @click="saveDeliveryInfo">{{$t('saveDeliveryLabel')}}</v-btn>
            </div>
            <v-btn class="primary" @click="editMode = true" v-if="!isAdmin">{{$t('editDataLabel')}}</v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </div>
</template>
<script>
  export default {
    name: "CompanyProfile",
    data() {
      return {
        canEditPrice: false,
        savingDeliveryInformation: false,
        deliveryInformation: '',
        companyInfo: {
          name: '',
          city: '',
          address: '',
          postalCode: '',
          deliveryInformation: '',
        },
        incoterms: ["Incoterm 1", "Incoterm 2", "Incoterm 3", "Incoterm 4"],
        paymentTerms: [
          "Payment Term 1",
          "Payment Term 2",
          "Payment Term 3",
          "Payment Term 4",
        ],
        priceList: ["PriceList 1", "PriceList 2", "PriceList 3", "PriceList 4"],
        snackbar: {
          color: "success",
          text: "",
          show: true,
        },
        mode: "",
        editMode: false,
        company: {},
        snackbar: {
          show: true,
          message: "",
        }
      };
    },
    props: {
      companyId: Number,
      isAdmin: Boolean,
    },
    methods: {
      getCompany() {
        this.$EventBus.$emit("loading", true);
        var companyId = this.$props.companyId;
        this.axios
          .get("api/company/getbyid/", {
            params: {
              id: companyId,
            },
          })
          .then((response) => {
            console.log(response)
          this.$EventBus.$emit("loading", false);
            this.company = response.data;
            this.companyInfo = response.data;
            this.deliveryInformation = this.company.deliveryInformation
            this.canEditPrice = this.company.canEditPrice
          })
          .catch((error) => {
          });
      },
      saveChanges() {
        this.editMode = false;
        this.snackbar.message = this.$t("companyEditedLabel");
        this.$EventBus.$emit('snackbar', this.snackbar)
      },
      saveDeliveryInfo() {
        this.savingDeliveryInformation = true
        const deliveryInfo = {
          companyId: this.$props.companyId,
          deliveryInformation: this.deliveryInformation,
          canEditPrice : this.canEditPrice
        }
        this.axios
          .post("api/company/updateCompanyDeliveryInformation", deliveryInfo)
          .then(() => {
            this.snackbar.message = this.$t("companyEditedLabel")
            this.$EventBus.$emit("snackbar", this.snackbar);
            this.savingDeliveryInformation = false
          }).catch(error => {
            this.snackbar.message = error.message
            this.$EventBus.$emit("snackbar", this.snackbar);
          })
      }
    },
    mounted() {
      this.getCompany();
    },
  };
</script>
<style scoped>
  .v-text-field {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
</style>